import * as React from 'react';

import type { IconProps } from '../../types';

/**
 * Infectiologist icon
 *
 * @category Medical
 */
const Infectiologist = React.forwardRef<SVGSVGElement, IconProps>(
  ({ 'data-testid': testId, size = 20, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        data-testid={testId}
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        role="img"
        aria-hidden="true"
        {...props}
      >
        <g clip-path="url(#infectiologist-a)">
          <path
            fill="currentColor"
            d="M16.075 2.985c.323.024.503.515.54 1.091.011.564.143 1.043.587 1.187 1.115.24 2.362.468 3.406.972.54.275.983.155 1.355-.372.287-.408.839-1.14 1.307-.636.491.744-.936 1.643-.312 2.399.803.779 1.847 1.834 2.458 2.83.288.407.708.467 1.223.263a3.8 3.8 0 0 1 .876-.24c.527-.023.755.48.395.864-.383.408-1.187.6-1.343 1.043-.18.6.228 1.271.288 1.895.42 1.103-.455 2.794 1.08 3.058.287.048.611.144.875.276.468.264.384.815-.132.935-.624.132-1.511-.18-1.847.288-.491.983-.971 2.578-1.69 3.537-.72.972 1.426 1.631.863 2.543-.864.683-1.727-1.331-2.65-.492-.984.995-2.555 1.451-3.37 2.279-.336.515.48 1.678-.132 2.182-1.02.468-.983-1.679-1.69-1.787-1.008-.084-2.411.228-3.526-.012-.732-.156-1.235-.012-1.451.864-.144.54-.432 1.043-.792 1.007-1.127-.036.132-2.015-.48-2.47-.275-.276-.767-.432-1.127-.648-1.235-.372-2.194-2.494-3.501-1.271-.252.192-.624.504-.924.504-.503 0-.66-.516-.347-.924.287-.42.863-.755.983-1.151.132-.396-.132-.707-.336-1.055-.647-.9-.96-2.195-1.427-3.13-.408-.552-1.403-.072-1.967-.264-.48-.132-.563-.672-.131-.935.863-.432 1.906-.099 1.906-1.451s.54-2.567.432-3.754c-.168-.455-1.007-.66-1.403-1.067-.384-.384-.144-.887.396-.863.575.024 1.27.527 1.726.347.948-.671 1.44-1.978 2.41-2.698.588-.455.792-.923.396-1.583a3.8 3.8 0 0 1-.371-.851c-.108-.528.36-.828.803-.516.408.276.684.936 1.08 1.127.383.24.815-.024 1.343-.24.887-.42 2.05-.587 2.962-.815.887-.156.311-2.182 1.127-2.29h.132zm-.204 3.441c-9.09.156-12.963 12.232-5.48 17.604 4.628 3.694 11.86 1.775 14.366-3.513 3.31-6.092-1.871-14.21-8.658-14.09zm.144 10.973c2.758.96 2.338 4.785-.36 5.468-5.66 1.08-5.216-6.823.132-5.552l.228.072zm-.264 1.115c-.636 0-1.571.156-2.303.456-.371.156-.611.312-.755.444a.4.4 0 0 0-.096.12v.023c0 .42.228 1.068.684 1.62.455.563.923.767 1.175.767.54 0 1.127-.18 1.559-.48s.575-.611.575-.863c0-.672-.108-1.283-.311-1.68-.168-.335-.324-.395-.516-.395zm4.737-5.504c3.537.408 3.645 6.535-.096 6.655-3.994.072-4.293-6.787-.132-6.68l.216.025zm-.504 1.307c-.348 0-.732.18-1.043.552a2.17 2.17 0 0 0-.516 1.355c0 .395.24 1.019.72 1.595.491.575.995.791 1.259.791.227 0 .611-.168 1.019-.72.384-.527.6-1.187.6-1.666 0-.348-.204-.828-.672-1.26-.456-.431-.983-.647-1.367-.647m-5.504-4.64c1.69.011 3.106 2.374 2.662 3.825-.432 1.415-1.775 2.961-3.31 3.237-1.607.276-3.79-2.578-3.37-4.185.468-1.547 2.387-2.77 3.886-2.878zm-.264 1.066c-2.518-.3-3.67 3.958-1.031 4.605 2.734.696 4.197-3.993 1.259-4.58z"
          />
        </g>
        <defs>
          <clipPath id="infectiologist-a">
            <path fill="currentColor" d="M0 0h32v32H0z" />
          </clipPath>
        </defs>
      </svg>
    );
  }
);

Infectiologist.displayName = 'Infectiologist';

export { Infectiologist };
